export default "/dist/fonts/Exo2-Light.ttf";